<div class="p-grid form-container edit-profile">
  <form [formGroup]='editProfileForm'>

    <div class="p-g-12 p-0">
      <!-- <div class="p-g-3">
        <img style="width:100%" [src]="profileUrl" />
        <div class='display-image profile-btn'>
          <app-file-uploader id="app-file-uploader" (onFileUpload)="onUploadProfileImage($event)" accept="image/*"
            [uploadButtonLabel]="chooseLabel"></app-file-uploader>
        </div>
      </div> -->

      <div class="p-g-9 p-0">
        <div class="form-field p-g-12 p-md-6 p-lg-6">
          <div class="form-label">
            <label for="firstName" id="ariaLabelFirstName" translate>f_name</label>
          </div>
          <div class="form-control">
            <input formControlName="firstName" id="firstName"
              aria-labelledby="ariaLabelFirstName ariaLabelErrorFirstName" aria-required="true" type="text" pInputText
              disabled appNoWhiteSpace />
          </div>
          <div class="form-errors" id="ariaLabelErrorFirstName"
            *ngIf="editProfileForm.controls['firstName'].errors  && (editProfileForm.controls['firstName'].dirty || editProfileForm.controls['firstName'].touched||submitted)">
            <div [hidden]="!editProfileForm.controls['firstName'].errors.required" translate>
              first_name_required
            </div>
            <div [hidden]="!editProfileForm.controls['firstName'].errors.maxlength" translate>
              max_length
            </div>
          </div>
        </div>

        <div class="form-field p-g-12 p-md-6 p-lg-6">
          <div class="form-label">
            <label for="lastName" id="lastName" translate>l_name</label>
          </div>
          <div class="form-control">
            <input formControlName="lastName" id="lastName" aria-labelledby="ariaLabelLirstName ariaLabelErrorLirstName"
              aria-required="true" type="text" pInputText appNoWhiteSpace disabled />
          </div>
          <div class="form-errors" id="ariaLabelErrorLirstName"
            *ngIf="editProfileForm.controls['lastName'].errors  && (editProfileForm.controls['lastName'].dirty || editProfileForm.controls['lastName'].touched||submitted)">
            <div [hidden]="!editProfileForm.controls['lastName'].errors.required" translate>
              last_name_required
            </div>
            <div [hidden]="!editProfileForm.controls['lastName'].errors.maxlength" translate>
              max_length
            </div>
          </div>
        </div>

        <div class="form-field p-g-12 p-md-12 p-lg-12">
          <div class="form-label">
            <label for="email" id="email" translate>email</label>
          </div>
          <div class="form-control">
            <input formControlName="email" id="email" aria-labelledby="ariaLabelEmail ariaLabelErrorEmail"
              aria-required="true" type="text" pInputText appNoWhiteSpace disabled />
          </div>
          <div class="form-errors" id="ariaLabelErrorEmail"
            *ngIf="editProfileForm.controls['email'].errors  && (editProfileForm.controls['email'].dirty || editProfileForm.controls['email'].touched||submitted)">
            <div [hidden]="!editProfileForm.controls['email'].errors.required" translate>
              email_required
            </div>
            <div [hidden]="!editProfileForm.controls['email'].errors.email" translate>
              email_invalid
            </div>
          </div>
        </div>

        <div class="form-field p-g-12 p-md-12 p-lg-12">
          <div class="form-label">
            <label for="phone" id="ariaLabelPhone" translate>phone</label>
          </div>
          <div class="p-g-3 p-input-group mobile-number p-0">
            <span class="p-input-group-addon">
              <i class="fa fa-plus"></i>
            </span>
            <input class="input-mobile-code" id="phoneCode" aria-labelledby="ariaLabelErrorPhoneCode"
              aria-required="true" type="text" pInputText formControlName="phoneCode" placeholder="Code"
              appNoWhiteSpace />
          </div>
          <div class="form-control p-g-9 p-g-nopad">
            <input formControlName="phone" id="phone" aria-labelledby="ariaLabelPhone ariaLabelErrorPhone"
              aria-required="true" type="text" pInputText appNoWhiteSpace />
          </div>
          <div class="form-errors" id="ariaLabelErrorPhoneCode"
            *ngIf="editProfileForm.controls['phoneCode'].errors  && (editProfileForm.controls['phoneCode'].dirty || editProfileForm.controls['phoneCode'].touched||submitted)">
            <div [hidden]="!editProfileForm.controls['phoneCode'].errors.required" translate>
              phone_code_required
            </div>
            <div [hidden]="!editProfileForm.controls['phoneCode'].errors.pattern" translate>
              number_only
            </div>
          </div>
          <div class="form-errors" id="ariaLabelErrorPhone"
            *ngIf="editProfileForm.controls['phone'].errors  && (editProfileForm.controls['phone'].dirty || editProfileForm.controls['phone'].touched||submitted)">
            <div [hidden]="!editProfileForm.controls['phone'].errors.required" translate>
              phone_number_required
            </div>
            <div [hidden]="!editProfileForm.controls['phone'].errors.pattern" translate>
              number_only
            </div>
            <div [hidden]="!editProfileForm.controls['phone'].errors.minlength" translate>
              min_length_phone_number
            </div>
            <div [hidden]="!editProfileForm.controls['phone'].errors.maxlength" translate>
              min_length_phone_number
            </div>
          </div>
        </div>
        <div class="col-12">
          <span (click)="redirectToAppReleaseHistory()" id="app-release-link" class="app-release-link" translate> lbl_app_release_history</span>
        </div>
        <div class="form-buttons p-g-12 p-g-nopad">
          <button pButton type="button" label="Save" icon="fa fa-check" (click)="updateProfile()"></button>
        </div>
      </div>
    </div>
  </form>
</div>
